import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TopBar.css';

const TopBar = ({ onAboutClick, mode, showAbout, authUser, authConfigured, onAuthClick, onSignOut, creditBalance, onBuyCredits }) => {
  const navigate = useNavigate();
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const popupRef = useRef(null);
  const badgeRef = useRef(null);

  useEffect(() => {
    if (!showCreditPopup) return;
    const handleClick = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target) &&
          badgeRef.current && !badgeRef.current.contains(e.target)) {
        setShowCreditPopup(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showCreditPopup]);

  const balance = creditBalance || {};
  const total = balance.total_credits;
  const hasBadge = authUser && total !== null && total !== undefined;

  return (
    <div id="top-bar" className={`${mode !== 'map' ? 'compact' : ''} ${showAbout ? 'show-above-popup' : ''}`}>
      <div id="text-container">
        <span className="bold-white-text" style={{ fontFamily: 'Inter, sans-serif', fontWeight: '600', letterSpacing: '-0.5px', fontSize: '25px' }}>
          anicha.earth<sup style={{ fontSize: '12px', fontWeight: '400' }}>beta</sup>
        </span>
        {mode === 'map' && <span className="grey-description">Earth timeline in detail</span>}
      </div>
      <div className="top-bar-actions">
        {hasBadge && (
          <span
            className="credit-badge"
            ref={badgeRef}
            onClick={() => setShowCreditPopup((v) => !v)}
          >
            {total} credit{total !== 1 ? 's' : ''}
          </span>
        )}
        {showCreditPopup && hasBadge && (
          <div className="credit-popup" ref={popupRef}>
            <div className="credit-popup-row">
              <span className="credit-popup-label">Free daily</span>
              <span className="credit-popup-value">{balance.free_credits ?? 0}</span>
            </div>
            <div className="credit-popup-row">
              <span className="credit-popup-label">Purchased</span>
              <span className="credit-popup-value">{balance.purchased_credits ?? 0}</span>
            </div>
            <div className="credit-popup-divider" />
            <div className="credit-popup-row total">
              <span className="credit-popup-label">Total</span>
              <span className="credit-popup-value">{total}</span>
            </div>
            <p className="credit-popup-hint">1 credit = 1 AI Zoom image. 3 free credits reset daily.</p>
            {onBuyCredits && (
              <button className="credit-popup-buy" onClick={() => { setShowCreditPopup(false); onBuyCredits(); }}>
                Buy 100 credits — $2.90
              </button>
            )}
          </div>
        )}
        {authUser && (
          <span
            onClick={(e) => { e.stopPropagation(); navigate('/history'); }}
            style={{ color: '#64b5f6', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }}
          >
            History
          </span>
        )}
        {authUser && (
          <span
            onClick={(e) => { e.stopPropagation(); navigate('/api'); }}
            style={{ color: '#64b5f6', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }}
          >
            API
          </span>
        )}
        {authConfigured && (
          <button
            className={`auth-button ${authUser ? 'signed-in' : ''}`}
            onClick={authUser ? onSignOut : onAuthClick}
            aria-label={authUser ? 'Sign out' : 'Sign in'}
          >
            {authUser ? 'Sign out' : 'Sign in'}
          </button>
        )}
        <button className="menu-button" onClick={onAboutClick} aria-label={showAbout ? "Close" : "Menu"}>
          {showAbout ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="5" r="2" fill="white"/>
              <circle cx="12" cy="12" r="2" fill="white"/>
              <circle cx="12" cy="19" r="2" fill="white"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default TopBar;
